import { Component,  OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { MenuService } from '../services/menu.service';
import { RoutingState } from '../services/routingState';
import 'rxjs/add/operator/map'
import { CartService } from '../services/cart.service';
import { NavigationEnd, Router } from '@angular/router';
import { Common } from '../model/common.model';
import { DataService } from '../services/data.service';
import { SEOService } from '../services/seo.service';
import { ContactService } from '../services/contact.service';
//import { IpServiceService } from '../ip-service.service';
import { Observable, Subject, Subscription} from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { filter, mergeMap, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  products: any[] = [];
  numProducts: number = 0;
  cartTotal: number = 0;
  sessionId!: string;
  isNotLoggedIn: boolean = true;
  txtSearch: any;
  webtype: string;
  user: string;  
  UserType: any;
  businesstype: string;
  webname: string;
  isactive: any;
  iswishshow: any;
  isrfqshow: any;
  headerlinks: any;
  titlenames: any;
  contactDtl: any = [];
  address: any = [];
  isheaderbanner:any;
  addess: string = '';
  isShowSalesLogin: any;
  isShowRegistration: boolean = false;
  IsMuscle: any;
  israteshowforcu: any;
  Secondcontact: any;
  logourl: any;
  keyword:any='name';
  headermsg: any;  
  UrlWithFreeForm: any;
  UrlWithDetails: any;
  priceshowcust: any;
  isDisableElem: boolean = false;
  newpermission: any;
  itemCounter: number = 0;
  PriceRound: any;
  isumdescr:any;
   //@HostListener('window:resize', ['$event'])
  innerWidth: any;
  logoimageurl: any;
  wishlistlable: any;
  Searchplaceholder: string = 'Search here...';
  //ipAddress: string;
  umdescrlist:any;
  Allconfigurationlist: any = [];
  autoCompleteData:any=[];
  asyncSelected: string;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean; 
  dataSource: Observable<any>;
  selecteditem:any;
  flagtocheck:any=false;
  IsRMA:any;
  RMALable:any;
  clearsearch:any;
  isdescron:any='1';
  iskinter:any='';
  IsPunchOut:any='no';
  istranslate:any;
  customerId:any;
  private _routerSub = Subscription.EMPTY;
  //showAutoComplete: boolean = true;
  constructor(private http: HttpClient,private renderer: Renderer2, private seoService: SEOService, private routingState: RoutingState, private contactService: ContactService, private dataService: DataService, private menuService: MenuService, private cartService: CartService, private router: Router, private loadingService: LoadingService) {
    this._routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd))    
      .subscribe((value) => {        
    var punchOutType = Common.getWithExpiry("PunchOutType");
    this.iskinter=punchOutType;
this.IsPunchOut= Common.getWithExpiry("IsPunchOut");
    if (punchOutType == "Southern") {
      this.isDisableElem = true;
    }
    // If the header thinks the user is logged in but CustID has expired from
    // localStorage, reset all cart and auth state. This prevents stale in-memory
    // products[] from being re-inserted as new cart rows on the next login.
    if (!this.isNotLoggedIn && Common.getWithExpiry("CustID") == undefined && Common.getWithExpiry("UserID") == undefined) {
      this.isNotLoggedIn = true;
      this.user = '';
      this.products = [];
      this.numProducts = 0;
      this.cartTotal = 0;
      this.flagtocheck = false;
      this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url } });
    }
  });
    this.isheaderbanner=environment.isheaderbanner;
    this.istranslate=environment.istranslate;
    this.customerId=environment.customerId || '';
    //this.GetpriceRoundingsetting();
    this.GetHeaderPageConfigurations();
    this.geheaderlinks();
    //this.getSearchplaceholder();
    //this.getUrlWithDetails();
    //this.GetConfigforwishlistlable();
    //this.showpricetocustomers();
    //this.Getlogoimageurl();
  //this.getcupermisiions();  

    //this.geHeaderMsg();
    //this.getlogourl();
    //this.getwishconfig();
    //this.getrfqconfig();
    //this.salesLoginSetting();
    //this.registrationSetting();
    //this.getIsMuscle();
    this.getcontactusSecondDetails();
    //this.getalldevicenames();
  }
  // getcupermisiions(){
  //   this.israteshowforcu = true;
  //   if (Common.getWithExpiry("UserType") == '3') {
  //     var permissions = Common.getWithExpiry("Permission").split(';');
  //     if (permissions.indexOf("SP") != -1) {
  //       this.israteshowforcu = true;
  //     }
  //     else {
  //       this.israteshowforcu = false;
  //     }
  //   }
  // }
  GetpriceRoundingsetting() {
    this.PriceRound = this.dataService.Getconfigbykey("PriceRound");
    if (this.PriceRound == null || this.PriceRound == undefined || this.PriceRound == '') {
      this.PriceRound = Common.getWithExpiry("PriceRound");
    }
    if (this.PriceRound == null || this.PriceRound == undefined || this.PriceRound == '') {
      this.dataService.GetpriceRoundingsetting().subscribe((res: any) => {
        this.PriceRound = res;
        Common.setWithExpiry("PriceRound", this.PriceRound);
      });
    }
  }


  getalldevicenames(){
    this.dataService.GetAllDevicenames().subscribe((res: any) => {
      var devicename = res;
      console.log('devicename',devicename);
    });
    this.dataService.GetAllDevicenames1().subscribe((res: any) => {
      var devicename = res;
      console.log('devicename1',devicename);
    });

  }

  searchall(){
    this.dataSource =new Observable((observer: any) => {
      // Runs on every search
      observer.next(this.asyncSelected);
    }).pipe(mergeMap((token: string) => this.filterResults(token)));
  }

  filterResults(token: string) {
    var Guestwarehouse = Common.getWithExpiry("Guestwarehouse");
    var wh = (Common.getWithExpiry("warehouse") == undefined ? Guestwarehouse : Common.getWithExpiry("warehouse"));
    var pmodel = {
      word: token,
      PageNo: 1,
      PageSize: 10,
      warehouse: wh,
      type: 0,
      customer: Common.getWithExpiry("CustID"),
      company_sy: Common.getWithExpiry("company_sy"),
      usercode: Common.getWithExpiry("usercode")
    }
    // adjust the remote url.
    //const url = '${this.url}?searchTerm=token';
    return this.http.post(environment.APIUrl + '/Product/GetProductListBySearchforheader', pmodel, { headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' }) })
      // if your backend does the filtering, just return the results.
      // oterwise we have to massage them a bit
      .map((results: any[]) => results.filter(res => res.freeform.toLowerCase().indexOf(token.toLowerCase()) > -1));
  }
  typeaheadOnSelect(event){
this.selecteditem=event.item;
this.router.navigate(['productdetail', event.item.itemname,event.item.links]);
//this.selecteditem=undefined;
if(this.clearsearch=='1'){
  this.asyncSelected=undefined;
}else{
this.asyncSelected=event.item.itemname;
}
  }
  
  replaceAll(word, search, replacement) {
    return word.replace(new RegExp(search, 'g'), replacement);
  };
  gotosouthern(){
    var geturl = Common.getWithExpiry("BuyerCookie");
    this.router.navigate(['/southerquote/' + geturl.toLowerCase()])
  }

  GetHeaderPageConfigurations() {

    if (this.Allconfigurationlist == null || this.Allconfigurationlist == undefined || this.Allconfigurationlist == '') {
      try {
        this.Allconfigurationlist = JSON.parse(Common.getWithExpiry("Allconfigs"));
      } catch (ed) { }
    }
    if (this.Allconfigurationlist == null || this.Allconfigurationlist == undefined || this.Allconfigurationlist == '') {
      this.dataService.GetAllConfiguration().subscribe((data: any) => {
        this.Allconfigurationlist = data;
        Common.setWithExpiry("Allconfigs", JSON.stringify(this.Allconfigurationlist));
        for (var i = 0; i < this.Allconfigurationlist.length; i++) {
          if (this.Allconfigurationlist[i].ConfigKey == "IsMuscle") {
            this.IsMuscle = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "SalesLogin") {
            this.isShowSalesLogin = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "Registration") {
            this.isShowRegistration = (this.Allconfigurationlist[i].ConfigValue == '1' ? true : false);
          }
          
          if (this.Allconfigurationlist[i].ConfigKey == "ShowPrices") {
            this.priceshowcust = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "iswishlist") {
            this.iswishshow = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "headermsg") {
            this.headermsg = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "logourl") {
            this.logourl = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "isrfqlist") {
            this.isrfqshow = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "websitetype") {
            this.webtype = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "businesstype") {
            this.businesstype = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "Searchplaceholder") {
            this.Searchplaceholder = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "wishlistlable") {
            this.wishlistlable = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "UrlWithDetails") {
            this.UrlWithDetails = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "UrlWithFreeForm") {
            this.UrlWithFreeForm = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "logoimageurl") {
            this.logoimageurl = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "PriceRound") {
            this.PriceRound = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "IsRMA") {
            this.IsRMA = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "RMALable") {
            this.RMALable = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "clearsearch") {
            this.clearsearch = this.Allconfigurationlist[i].ConfigValue;
          }
          if (this.Allconfigurationlist[i].ConfigKey == "NewPermission") {
            this.newpermission = this.Allconfigurationlist[i].ConfigValue;
            this.newpermissionsetting();
          }
        }
        this.getumdescrconfig();
      })
    }
    else {
      for (var i = 0; i < this.Allconfigurationlist.length; i++) {
        if (this.Allconfigurationlist[i].ConfigKey == "IsMuscle") {
          this.IsMuscle = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "SalesLogin") {
          this.isShowSalesLogin = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "Registration") {
          this.isShowRegistration = (this.Allconfigurationlist[i].ConfigValue == '1' ? true : false);
        }
        if (this.Allconfigurationlist[i].ConfigKey == "ShowPrices") {
          this.priceshowcust = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "iswishlist") {
          this.iswishshow = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "headermsg") {
          this.headermsg = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "logourl") {
          this.logourl = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "isrfqlist") {
          this.isrfqshow = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "websitetype") {
          this.webtype = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "businesstype") {
          this.businesstype = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "Searchplaceholder") {
          this.Searchplaceholder = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "wishlistlable") {
          this.wishlistlable = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "UrlWithDetails") {
          this.UrlWithDetails = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "UrlWithFreeForm") {
          this.UrlWithFreeForm = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "logoimageurl") {
          this.logoimageurl = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "PriceRound") {
          this.PriceRound = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "IsRMA") {
          this.IsRMA = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "RMALable") {
          this.RMALable = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "clearsearch") {
          this.clearsearch = this.Allconfigurationlist[i].ConfigValue;
        }
        if (this.Allconfigurationlist[i].ConfigKey == "NewPermission") {
          this.newpermission = this.Allconfigurationlist[i].ConfigValue;
          this.newpermissionsetting();
        }
      }
      this.getumdescrconfig();
    }
  }
  newpermissionsetting() {
    if (this.newpermission == "1") {
      if(Common.getWithExpiry("UserType") == '3'){
        var permis = JSON.parse(Common.getWithExpiry("ProfileLog"));
        this.israteshowforcu = permis[8];
      }
      else{
        this.israteshowforcu = true;
      }      
    }
    else {
      if (Common.getWithExpiry("UserType") == '3') {
        var permissions = Common.getWithExpiry("Permission").split(';');
        if (permissions.indexOf("SP") != -1) {
          this.israteshowforcu = true;
        }
        else {
          this.israteshowforcu = false;
        }
      }
      else {
        this.israteshowforcu = true;
      }
    }
  }
  getIsMuscle() {
    this.IsMuscle = Common.getWithExpiry("IsMuscle");
    if (this.IsMuscle == null || this.IsMuscle == undefined) {
      this.dataService.GetConfigForIsMuscle().subscribe((data: any) => {
        this.IsMuscle = data;
        Common.setWithExpiry("IsMuscle", this.IsMuscle);
      })
    }
  }
  getcontactusSecondDetails() {
    try {
      if (Common.getWithExpiry("Secondcontact") != undefined) {
        var Secondcontact = JSON.parse(Common.getWithExpiry("Secondcontact"));
      }
    } catch (ed) { }
    if (Secondcontact == null || Secondcontact == undefined || Secondcontact.length == 0) {
      this.contactService.getContactSecondaryDetails().subscribe((res: any) => {
        this.Secondcontact = res;
        this.getContactDtl();
        Common.setWithExpiry("Secondcontact", JSON.stringify(this.Secondcontact));
      });
    }
    else {
      this.Secondcontact = Secondcontact;
      this.getContactDtl();
    }
  }
  getContactDtl() {
    try {
      if (Common.getWithExpiry("contactDtl") != undefined) {
        var contactDtl = JSON.parse(Common.getWithExpiry("contactDtl"));
      }
    } catch (ex) { }
    if (contactDtl == null || contactDtl == undefined || contactDtl == '') {
      this.contactService.getContact(Common.getWithExpiry("company_sy")).subscribe((res: any) => {
        this.contactDtl = res;
        Common.setWithExpiry("contactDtl", JSON.stringify(this.contactDtl));
        if (this.Secondcontact.cName == undefined || this.Secondcontact.cName == null || this.Secondcontact.cName == '') {
          Common.setWithExpiry("cpname", this.contactDtl.name);
          this.webname = this.contactDtl.name;
        }
        else {
          Common.setWithExpiry("cpname", this.Secondcontact.cName);
          this.webname = this.Secondcontact.cName;
        }
        Common.setWithExpiry("company_cu", this.contactDtl.company_cu);
        Common.setWithExpiry("company_it", this.contactDtl.company_it);
        Common.setWithExpiry("company_sy", this.contactDtl.company_sy);
        try {
          var getarr = this.contactDtl.adr.trim().replace('[', '').replace(']', '').split(',');
          for (var i = 0; i < getarr.length; i++) {
            var adrd = getarr[i].trim().replace('"', '').replace('"', '');
            adrd = adrd.trim();
            this.address.push(adrd);
            if (adrd != '') {
              this.addess = this.addess + ", " + adrd;
            }
          }
        } catch (ed) { }
        var geturl = Common.getWithExpiry("cpname");
        this.seoService.setauthormetatag(geturl + ' ' + this.address + ' ' + this.contactDtl.state + ' ' + this.contactDtl.postal_code + ' ' + this.contactDtl.country_code + ' ' + this.contactDtl.phone + ' ' + this.contactDtl.co_email + ' ' + this.contactDtl.co_web + ' ' + this.contactDtl.fax);

      })
    }
    else {
      this.contactDtl = contactDtl;
      if (this.Secondcontact.cName == undefined || this.Secondcontact.cName == null || this.Secondcontact.cName == '') {
        Common.setWithExpiry("cpname", this.contactDtl.name);
        this.webname = this.contactDtl.name;
      }
      else {
        Common.setWithExpiry("cpname", this.Secondcontact.cName);
        this.webname = this.Secondcontact.cName;
      }
      Common.setWithExpiry("company_cu", this.contactDtl.company_cu);
      Common.setWithExpiry("company_it", this.contactDtl.company_it);
      Common.setWithExpiry("company_sy", this.contactDtl.company_sy);
      var getarr = this.contactDtl.adr.trim().replace('[', '').replace(']', '').split(',');
      for (var i = 0; i < getarr.length; i++) {
        var adrd = getarr[i].trim().replace('"', '').replace('"', '');
        adrd = adrd.trim();
        this.address.push(adrd);
        if (adrd != '') {
          this.addess = this.addess + ", " + adrd;
        }
      }
      var geturl = Common.getWithExpiry("cpname");
      this.seoService.setauthormetatag(geturl + ' ' + this.address + ' ' + this.contactDtl.state + ' ' + this.contactDtl.postal_code + ' ' + this.contactDtl.country_code + ' ' + this.contactDtl.phone + ' ' + this.contactDtl.co_email + ' ' + this.contactDtl.co_web + ' ' + this.contactDtl.fax);
    }
  }


  salesLoginSetting() {
    this.isShowSalesLogin = this.dataService.Getconfigbykey("SalesLogin");
    if (this.isShowSalesLogin == undefined || this.isShowSalesLogin == null || this.isShowSalesLogin == '') {
      this.isShowSalesLogin = Common.getWithExpiry("isShowSalesLogin");
    }
    if (this.isShowSalesLogin == undefined || this.isShowSalesLogin == null || this.isShowSalesLogin == '') {
      this.dataService.SalesLoginSetting().subscribe((res: any) => {
        this.isShowSalesLogin = res;
        Common.setWithExpiry("isShowSalesLogin", this.isShowSalesLogin);
      });
    }
  }


  registrationSetting() {
    var RegistrationS = this.dataService.Getconfigbykey("Registration");
    if (RegistrationS == undefined || RegistrationS == null || RegistrationS == '') {
      RegistrationS = Common.getWithExpiry("RegistrationSetting");
    }
    if (RegistrationS == undefined || RegistrationS == null || RegistrationS == '') {
      this.dataService.RegistrationSetting().subscribe((data: any) => {
        var dd = data;
        Common.setWithExpiry("RegistrationSetting", dd);
        if (dd == "1") {
          this.isShowRegistration = true;
        }
        else {
          this.isShowRegistration = false;
        }
      });
    }
    else {
      if (RegistrationS == "1") {
        this.isShowRegistration = true;
      }
      else {
        this.isShowRegistration = false;
      }
    }
  }
  showpricetocustomers() {
    this.priceshowcust = this.dataService.Getconfigbykey("ShowPrices");
    if (this.priceshowcust == null || this.priceshowcust == undefined || this.priceshowcust == '') {
      this.priceshowcust = Common.getWithExpiry("priceshowcust");
    }
    if (this.priceshowcust == null || this.priceshowcust == undefined || this.priceshowcust == '') {
      this.dataService.showpricetocustomers().subscribe((data: any) => {
        this.priceshowcust = data;
        Common.setWithExpiry("priceshowcust", this.priceshowcust);
      })
    }
  }
  getwishconfig() {
    this.iswishshow = this.dataService.Getconfigbykey("iswishlist");
    if (this.iswishshow == null || this.iswishshow == undefined || this.iswishshow == '') {
      this.iswishshow = Common.getWithExpiry("iswishshow");
    }
    if (this.iswishshow == null || this.iswishshow == undefined || this.iswishshow == '') {
      this.dataService.Getwishlistfeatureonoff().subscribe((res: any) => {
        this.iswishshow = res;
        Common.setWithExpiry("iswishshow", this.iswishshow);
      });
    }
  }
  geHeaderMsg() {
    this.headermsg = this.dataService.Getconfigbykey("headermsg");
    if (this.headermsg == null || this.headermsg == undefined || this.headermsg == '') {
      this.headermsg = Common.getWithExpiry("headermsg");
    }
    if (this.headermsg == null || this.headermsg == undefined || this.headermsg == '') {
      this.dataService.getconfigfortheheadermsg().subscribe((res: any) => {
        this.headermsg = res;
        Common.setWithExpiry("headermsg", this.headermsg);
      });
    }
  }
  getlogourl() {
    this.logourl = this.dataService.Getconfigbykey("logourl");
    if (this.logourl == null || this.logourl == undefined || this.logourl == '') {
      this.logourl = Common.getWithExpiry("logourl");
    }
    if (this.logourl == null || this.logourl == undefined || this.logourl == '') {
      this.dataService.geturlforthelogo().subscribe((res: any) => {
        this.logourl = res;
        Common.setWithExpiry("logourl", this.logourl);
      });
    }
  }
  getrfqconfig() {
    this.isrfqshow = this.dataService.Getconfigbykey("isrfqlist");
    if (this.isrfqshow == null || this.isrfqshow == undefined || this.isrfqshow == '') {
      this.isrfqshow = Common.getWithExpiry("isrfqshow");
    }
    if (this.isrfqshow == null || this.isrfqshow == undefined || this.isrfqshow == '') {
      this.dataService.Getrfqlistfeatureonoff().subscribe((res: any) => {
        this.isrfqshow = res;
        Common.setWithExpiry("isrfqshow", this.isrfqshow);
      });
    }
  }
  geheaderlinks() {
    try {
      if (Common.getWithExpiry('headerlinks') != undefined) {
        var headerlinks = JSON.parse(Common.getWithExpiry('headerlinks'));
      }
    } catch (ed) { }
    if (headerlinks == null || headerlinks == undefined || headerlinks.length == 0) {

      this.dataService.Getheaderlinkslist().subscribe((res: any) => {
        this.headerlinks = res;
        Common.setWithExpiry('headerlinks', JSON.stringify(this.headerlinks));
      });
    }
    else {
      this.headerlinks = headerlinks;
    }
  }

  // getIP() {
  //   this.ip.getIPAddress().subscribe((res: any) => {
  //     this.ipAddress = res.ip;
  //   });
  // }

  private loadTypekitFont(): void {
    if (this.customerId === 'techrim') {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'stylesheet');
      this.renderer.setAttribute(link, 'href', 'https://use.typekit.net/eic4gtl.css');
      this.renderer.appendChild(document.head, link);
    }
  }

  private initializeGoogleTranslate(): void {
    if (this.istranslate == 1) {
      let attempts = 0;
      const maxAttempts = 100; // 10 seconds total (100 * 100ms)
      
      const checkGoogleTranslate = setInterval(() => {
        attempts++;
        
        if (typeof (window as any).google !== 'undefined' && (window as any).google.translate) {
          clearInterval(checkGoogleTranslate);
          
          const element = document.getElementById('google_translate_element');
          if (element) {
            // Clear existing widget if any
            element.innerHTML = '';
            
            try {
              new (window as any).google.translate.TranslateElement(
                { pageLanguage: 'en' }, 
                'google_translate_element'
              );
            } catch (e) {
              console.error('Google Translate initialization error:', e);
            }
          }
        } else if (attempts >= maxAttempts) {
          clearInterval(checkGoogleTranslate);
          console.warn('Google Translate script not loaded after 10 seconds');
        }
      }, 100);
    }
  }

  ngOnInit() {
    this.searchall();
    this.loadTypekitFont();
    this.initializeGoogleTranslate();
    this.cartService.southernAdded$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.isDisableElem = data.result;
      if (Common.getWithExpiry("Name") != undefined) {
        this.isNotLoggedIn = false;
        this.user = Common.getWithExpiry("Name");
      }
    });

    // try
    // {
    // this.innerWidth = window.innerWidth;
    // }
    // catch(ex){}
    //this.getIP();

    this.UserType = (Common.getWithExpiry("SalesUserType") == undefined ? (Common.getWithExpiry("UserType") == undefined ? "1" : Common.getWithExpiry("UserType")) : Common.getWithExpiry("SalesUserType").toString());
    if (Common.getWithExpiry("UserID") != undefined || Common.getWithExpiry("SalesUserID") != undefined) {
      this.isNotLoggedIn = false;
      if (this.UserType == 4) {
        this.user = "Guest";
      }
      else {
        if (this.UserType == 2) {
          var getuser = Common.getWithExpiry("CustID")
          if (getuser != undefined && getuser != null) {
            this.user = Common.getWithExpiry("Name") + ' As ' + getuser;
          }
          else {
            this.user = Common.getWithExpiry("Name");
          }
        }
        else {
          this.user = Common.getWithExpiry("Name");
        }
      }
    }
    else {
      this.isNotLoggedIn = true;
    }




    this.sessionId = Common.getSessionId();
    if (Common.getWithExpiry("IsPunchOut") == "Yes") {
      this.cartService.deleteCartItemPunchOut(Common.getWithExpiry("CustID")).subscribe((res: any) => {
      });
    }
    else {
      this.getCartItems();
    }

    this.cartService.productAdded$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.getCartItems();
      
    });
    this.cartService.productAdded1$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.itemCounter++;
      
      if (this.itemCounter == data.data) {
        this.itemCounter = 0;
        var missingItems = Common.getWithExpiry("MissingItems");
        if (missingItems != undefined) {
          this.cartService.sendMissingProductEmail(missingItems).subscribe((res: any) => {
          });
        }

        //setTimeout(() => {                           //<<<---using ()=> syntax
          if (this.numProducts > 0) {
            this.router.navigate(['/viewcart']);
          }
          else {
            this.sendMessage('stop');
          }
        //}, 1000);

      }
    });

    

    this.cartService.productUpdatedLogin$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.isNotLoggedIn = false;
      // Only re-insert session cart items when the user was browsing as a guest
      // (CustID was not set before login). If CustID is already set the cart lives
      // in the DB under that user — calling Addnewproduct would double quantities
      // because InsertCart does cartItem.Quantity += cart.Quantity for existing rows.
      // wasGuest is true when the cart was loaded under a session ID (not a CustID).
      // cart.service.ts emits { products: sessionId } when userId was null (guest),
      // and { products: userId, sessionId } when userId was present (logged-in user).
      // So if data.sessionId is absent, the user was browsing as a guest.
      var wasGuest = (data == null || data.sessionId == null || data.sessionId == undefined);
      if(this.products!=undefined && this.products!=null && this.products.length>0 && this.flagtocheck==false && wasGuest){
        this.flagtocheck=true;        
      for (var t=0;t<this.products.length;t++) {        
        var prs = this.products[t];
      prs.product.quantity=prs.quantity;
      prs.product.Quantity=prs.quantity;      
      prs.product.sessionId = data.sessionId;
      this.deleteitemforsession(prs.product);
          this.Addnewproduct(prs.product,t,this.products.length);          
    }
    
  }
  else{
    this.getCartItems();
  }
      // this.cartService.updateCartForSession().subscribe(rr => {
      //   this.getCartItems();
      // })
      if (Common.getWithExpiry("IsPunchOut") == "Yes") {
        this.cartService.deleteCartItemPunchOut(Common.getWithExpiry("CustID")).subscribe((res: any) => {
        });
      }
      // else {
      //   this.cartService.updateCartForSession().subscribe(rr => {
      //     this.getCartItems();
      //   });
      // }

    });



    this.cartService.productUpdated$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.cartTotal = data.cartTotal;
      this.numProducts = data.product.length;

    });
    this.cartService.customeradded$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.user = data;
      this.newpermissionsetting();
      //this.getcupermisiions();
    });
    // this.webtype = this.dataService.Getconfigbykey("websitetype");
    // if (this.webtype == null || this.webtype == undefined || this.webtype == '') {
    //     this.webtype = Common.getWithExpiry("websitetype");
    // }
    // if (this.webtype == null || this.webtype == undefined || this.webtype == '') {
    //     this.dataService.GetWebsiteType().subscribe((data: any) => {
    //         this.webtype = data;
    //         Common.setWithExpiry("websitetype", this.webtype);
    //     })
    // }

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.destroy$ = new Subject<void>();
  }

  closemobilemenu1() {
    
  //   try
  //   {
  //   if (this.innerWidth <= 426) {
  //     const element = this.renderer.selectRootElement("#mobilemenu1");
  //     element.click();
  //   }
  // }  catch(ex)  {}
  
    // this.renderer.addClass(element,"collapsed");
    // const element1 = this.renderer.selectRootElement("#mc-horizontal-menu-collapse");
    // this.renderer.removeClass(element1,"collapse");
    // this.renderer.removeClass(element1,"in");
    // this.renderer.addClass(element1,"collapsed");

    //this.renderer.setStyle(element1,"height","0px");

  }

  sendMessage(message): void {
    this.loadingService.LoadingMessage(message);
  }

  register() {
    this.isactive = 'Register';
    // this.businesstype = this.dataService.Getconfigbykey("businesstype");
    // if (this.businesstype == null || this.businesstype == undefined || this.businesstype == '') {
    //   this.businesstype = Common.getWithExpiry("businesstype");
    // }
    // if (this.businesstype == null || this.businesstype == undefined || this.businesstype == '') {
    //   this.dataService.Getbusinesstype().subscribe((data1: any) => {
    //     this.businesstype = data1;
    //     Common.setWithExpiry("businesstype", this.businesstype);
    //     if (this.businesstype == "B2C") {
    //       this.router.navigate(['registration']);
    //     }
    //     else if (this.businesstype == "B2B") {
    //       this.router.navigate(['registration']);
    //     }
    //     else {
    //       this.router.navigate(['new-customer']);
    //     }
    //   })
    // }
    // else {
    if (this.businesstype == "B2C") {
      this.router.navigate(['registration']);
    }
    else if (this.businesstype == "B2B") {
      this.router.navigate(['b2b-registration']);
    }
    else {
      this.router.navigate(['new-customer']);
    }
    //}
  }


  deleteProduct(product) {

    var usrid = null
    if (Common.getWithExpiry("UserType") == '3' && this.IsMuscle) {
      usrid = Common.getWithExpiry("UserID");
    }
    else {
      usrid = Common.getWithExpiry("CustID");
    }
    this.cartService.deleteCartItem(product.itemnumber, product.um).subscribe((res: any) => {
      var getirl = window.location.href;
      this.getCartItems();
      if (getirl.indexOf('viewcart') != -1) {
        window.location.reload();
      }
    });
  }
  deleteitemforsession(item){
    this.cartService.deleteCartItemForSession(item.itemname, item.um, item.sessionId).subscribe((res: any) => {
    });
  }

  getCartItems() {
    var finalResult = [];
    var total = 0;

    if (Common.getWithExpiry("CustID") == undefined || Common.getWithExpiry("CustID") == null) {
      var usrid = null
      if (Common.getWithExpiry("UserType") == '3' && this.IsMuscle) {
        usrid = Common.getWithExpiry("UserID") + Common.getWithExpiry("CustID");
      }
      else {
        usrid = Common.getWithExpiry("CustID");
      }
      this.cartService.getCartItemByUserID().subscribe((res: any) => {
        var getdata = res;
        if (getdata != undefined && getdata != null && getdata.length > 0) {
          for (let pp of getdata) {
total = Number(total) + Number(pp.Price);
            finalResult.push({ "product": { "RowID": pp.RowID, "links": pp.links, "itemnumber": pp.itemnumber, "itemname": pp.itemname, "parsedPrice": pp.PricePer, "um": pp.MeasureUnit, "image": pp.image, "freeform": pp.freeform, "descr1": pp.itemdesc }, "quantity": pp.Quantity });
          }
          this.products = finalResult;
          this.numProducts = finalResult.length;

          this.cartTotal = total;
        }
        else {
          this.products = [];
          this.numProducts = 0;
          this.cartTotal = 0;
        }


      });
    }
    else {
      var usrid = null;
      if (Common.getWithExpiry("UserType") == '3' && this.IsMuscle) {
        usrid = Common.getWithExpiry("UserID") + Common.getWithExpiry("CustID");
      }
      else {
        usrid = Common.getWithExpiry("CustID");
      }
      this.cartService.getCartItemByUserID().subscribe((res: any) => {
        var getdata = res;
        if (getdata != undefined && getdata != null && getdata.length > 0) {
          for (let pp of getdata) {
            total = Number(total) + Number(pp.Price);
            finalResult.push({ "product": { "RowID": pp.RowID, "links": pp.links, "itemnumber": pp.itemnumber, "itemname": pp.itemname, "parsedPrice": pp.PricePer, "um": pp.MeasureUnit, "image": pp.image, "freeform": pp.freeform, "descr1": pp.itemdesc }, "quantity": pp.Quantity });
          }
          this.products = finalResult;
          this.numProducts = finalResult.length;
          this.cartTotal = total;
        }
        else {
          this.products = [];
          this.numProducts = 0;
          this.cartTotal = 0;
        }

      });
    }
  }



  logout() {
    Common.removeWithExpiry("finalObj");
    Common.removeWithExpiry("warehouse");
    Common.removeWithExpiry("UserID");
    Common.removeWithExpiry("CustID");
    Common.removeWithExpiry("UserType");
    Common.removeWithExpiry("Permission");
    Common.removeWithExpiry("SalesUserID");
    Common.removeWithExpiry("SalesUserType");

    localStorage.clear();
    this.router.navigate(['/login']);
    this.getContactDtl();
    this.isNotLoggedIn = true;
    this.user = '';
    this.products = [];
    this.numProducts = 0;
    this.cartTotal = 0;
    this.getCartItems();
    //window.location.reload();

    this.flagtocheck = false;
    this.destroy$.next();
    this.destroy$.complete();
    this.destroy$ = new Subject<void>();
    this.ngOnInit();
    this.isactive = 'Login';

  }
  RemoveSpacesandSpeacialCharacters(str) {
    try {
      str = str.trim();
      var newString = str.replace(/[^A-Z0-9]+/ig, "-");
      return newString;
    }
    catch (ed) {

      return str;
    }
  }

  gotorfqpage() {
    if (this.router.url.toString().indexOf('rfqlist') != -1) {
      window.location.reload();
    }
    else {
      this.router.navigate(['/rfqlist']);
    }
  }
  gotormapage() {
    if (this.router.url.toString().indexOf('rma') != -1) {
      window.location.reload();
    }
    else {
      this.router.navigate(['/rma']);
    }
  }
  getSearchplaceholder() {
    this.Searchplaceholder = this.dataService.Getconfigbykey("Searchplaceholder");
    if (this.Searchplaceholder == null || this.Searchplaceholder == undefined || this.Searchplaceholder == '') {
      this.Searchplaceholder = Common.getWithExpiry("Searchplaceholder");
    }
    if (this.Searchplaceholder == null || this.Searchplaceholder == undefined || this.Searchplaceholder == '') {
      this.dataService.ConfigforSearchplaceholder().subscribe((data: any) => {
        this.Searchplaceholder = data;
        Common.setWithExpiry("Searchplaceholder", this.Searchplaceholder);
      });
    }
  }
  GetConfigforwishlistlable() {
    this.wishlistlable = this.dataService.Getconfigbykey("wishlistlable");
    if (this.wishlistlable == null || this.wishlistlable == undefined || this.wishlistlable == '') {
      this.wishlistlable = Common.getWithExpiry("wishlistlable");
    }
    if (this.wishlistlable == null || this.wishlistlable == undefined || this.wishlistlable == '') {
      this.dataService.GetConfigforwishlistlable().subscribe((data: any) => {
        this.wishlistlable = data;
        Common.setWithExpiry("wishlistlable", this.wishlistlable);
      });
    }
  }

  getUrlWithDetails() {
    this.UrlWithDetails = this.dataService.Getconfigbykey("UrlWithDetails");
    if (this.UrlWithDetails == null || this.UrlWithDetails == undefined || this.UrlWithDetails == '') {
      this.UrlWithDetails = Common.getWithExpiry("UrlWithDetails");
    }
    if (this.UrlWithDetails == null || this.UrlWithDetails == undefined || this.UrlWithDetails == '') {
      this.dataService.GetUrlWithDetailssetting().subscribe((data: any) => {
        this.UrlWithDetails = data;
        if (this.UrlWithDetails == '1') {
          this.getUrlWithFreeForm();
        }
        Common.setWithExpiry("UrlWithDetails", this.UrlWithDetails);
      })
    }
    else {
      if (this.UrlWithDetails == '1') {
        this.getUrlWithFreeForm();
      }
    }
  }
  getUrlWithFreeForm() {
    this.UrlWithFreeForm = this.dataService.Getconfigbykey("UrlWithFreeForm");
    if (this.UrlWithFreeForm == null || this.UrlWithFreeForm == undefined || this.UrlWithFreeForm == '') {
      this.UrlWithFreeForm = Common.getWithExpiry("UrlWithFreeForm");
    }
    if (this.UrlWithFreeForm == null || this.UrlWithFreeForm == undefined || this.UrlWithFreeForm == '') {
      this.dataService.GetUrlWithFreeFormsetting().subscribe((data: any) => {
        this.UrlWithFreeForm = data;
        Common.setWithExpiry("UrlWithFreeForm", this.UrlWithFreeForm);
      })
    }
  }

  Getlogoimageurl() {
    this.logoimageurl = this.dataService.Getconfigbykey("logoimageurl");
    if (this.logoimageurl == null || this.logoimageurl == undefined || this.logoimageurl == '') {
      this.logoimageurl = Common.getWithExpiry("logoimageurl");
    }
    if (this.logoimageurl == null || this.logoimageurl == undefined || this.logoimageurl == '') {
      this.dataService.ConfigurationForLogoImageurl().subscribe((data: any) => {
        this.logoimageurl = data;
        Common.setWithExpiry("logoimageurl", this.logoimageurl);
      })
    }
  }

  searchProduct() {
    var selecctedsatags = [];
    Common.setWithExpiry("selecctedsatags", JSON.stringify(selecctedsatags));
    Common.setWithExpiry('selectedmaj_class', '');
    Common.setWithExpiry('selectedprod_line', '');
    Common.setWithExpiry('selectedtreenode', '');
    Common.setWithExpiry('selectedsearch', this.txtSearch);
    // var model = {
    //   "LogType": "Search",
    //   "Description": "",
    //   "SearchKeyword": this.txtSearch,
    //   "CustID":Common.getWithExpiry("CustID"),
    //   "UserId": Common.getWithExpiry("UserID"),
    //   "ClientIP": this.ipAddress
    // }

    // this.dataService.AddActivityLog(model).subscribe((res: any) => {
    // });
    this.router.navigate(['search', this.asyncSelected]);
    
    if(this.clearsearch=='1'){      
      this.asyncSelected=undefined;
        this.txtSearch = '';
    }
    this.selecteditem=undefined;

  }

  SetActiveTab(tabname) {
    this.isactive = tabname;
  }

  catClick() {
    this.isactive = 'Categories';
    this.router.navigate(['categories']);
  }


  prodClick() {
    this.isactive = 'Products';
    this.router.navigate(['brands']);
  }


  conClick() {
    this.isactive = 'Contact';
    this.router.navigate(['contact']);
  }


  accClick() {
    this.isactive = 'Account';
    this.router.navigate(['dashboard']);
  }

  slogClick() {
    this.isactive = 'SLogin';
    this.router.navigate(['sales-login']);
  }

  logClick() {
    this.isactive = 'Login';
    this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url } });      
  }

  keyDown(event) {
    //this.txtSearch=event;
    try{
    if (this.txtSearch != null && this.txtSearch != "undefined" && this.txtSearch != "") {
      this.getAutoCompleteProduct();
      try{
      const element = this.renderer.selectRootElement("#autoul");
      element.focus();
      }catch(ed){}
    }
    else {
      this.autoCompleteData = [];
      //this.showAutoComplete = false;
    }
  }catch(ed){}
  }
  onFocused(event){

  }




  getAutoCompleteProduct() {
    var Guestwarehouse = Common.getWithExpiry("Guestwarehouse");
    var wh = (Common.getWithExpiry("warehouse") == undefined ? Guestwarehouse : Common.getWithExpiry("warehouse"));
    
    this.dataService.GetProductListBySearchforheader(this.txtSearch, 1, 10, wh, 0, Common.getWithExpiry("CustID")).subscribe((res: any) => {
      
      this.autoCompleteData = res;
      //this.showAutoComplete = true;

      for (var i = 0; i < this.autoCompleteData.length; i++) {
        var dd = JSON.parse(this.autoCompleteData[i].description1);
        this.autoCompleteData[i].desc = dd[0];
        this.autoCompleteData[i].id=i;
        this.autoCompleteData[i].name = this.autoCompleteData[i].itemname+'-'+this.autoCompleteData[i].links +'-'+this.autoCompleteData[i].description1 +'-'+this.autoCompleteData[i].manufacturer +'-'+this.autoCompleteData[i].freeform;
      }

  
    });
  }
  getumdescrconfig() {
    this.umdescrlist = [];
    this.isumdescr = this.dataService.Getconfigbykey("SettingForUMDescription");
    if (this.isumdescr == null || this.isumdescr == undefined || this.isumdescr == '') {
      this.isumdescr = Common.getWithExpiry("isumdescr");
    }
    if (this.isumdescr == null || this.isumdescr == undefined || this.isumdescr == '') {
      this.dataService.SettingForUMDescription().subscribe((res: any) => {
        this.isumdescr = res;
        Common.setWithExpiry("isumdescr", this.isumdescr);
        if (this.isumdescr == '1') {
          try {
            if (Common.getWithExpiry("umdescrlist") != undefined) {
              var umdescrlist = JSON.parse(Common.getWithExpiry("umdescrlist"));
            }
          } catch (ed) { }
          if (umdescrlist == null || umdescrlist == undefined || umdescrlist.length == 0) {
            this.dataService.getunitdescription().subscribe((res: any) => {
              this.umdescrlist = res;
              Common.setWithExpiry("umdescrlist", JSON.stringify(this.umdescrlist));
            });
          }
          else {
            this.umdescrlist = umdescrlist;
          }
        }

      });
    }
    else {
      if (this.isumdescr == '1') {
        try {
          if (Common.getWithExpiry("umdescrlist") != undefined) {
            var umdescrlist = JSON.parse(Common.getWithExpiry("umdescrlist"));
          }
        } catch (ed) { }
        if (umdescrlist == null || umdescrlist == undefined || umdescrlist.length == 0) {
          this.dataService.getunitdescription().subscribe((res: any) => {
            this.umdescrlist = res;
            Common.setWithExpiry("umdescrlist", JSON.stringify(this.umdescrlist));
          });
        }
        else {
          this.umdescrlist = umdescrlist;
        }
      }
    }
    
  }
  getumdescbyumcode(umcode) {
    if (this.isumdescr == '1') {
      for (var i = 0; i < this.umdescrlist.length; i++) {
        if (this.umdescrlist[i].code.toLowerCase() == umcode.toLowerCase()) {
          return this.umdescrlist[i].descr;
        }
      }
    }
    else {
      return umcode;
    }
  }
  clearsearchtext(item){    
    this.txtSearch=item.itemname;
    this.keyword=item.itemname;
    this.asyncSelected=item.itemname;
    this.selecteditem=undefined;
    this.router.navigate(['productdetail', item.itemname,item.links]);
  }
  selectProduct(event) {    
    try{
    if(this.txtSearch!=undefined && this.txtSearch.itemname!=undefined && this.txtSearch.links!=undefined){                  
    this.router.navigate(['productdetail', this.txtSearch.itemname,this.txtSearch.links]);
    this.txtSearch=undefined;
    }
    else{
      this.searchProduct();      
    }
  }catch(ex){}
  }
  selectProductNew(event) {    
    try{
    if(this.selecteditem!=undefined && this.selecteditem!=undefined && this.selecteditem.links!=undefined){            
    //this.router.navigate(['productdetail', this.selecteditem.itemname,this.selecteditem.links]);
    //this.asyncSelected=this.selecteditem.itemname;
    this.selecteditem=undefined;
    }
    else{
      this.searchProduct();      
    }
  }catch(ex){}
  }



 Addnewproduct(item1,indexs,lastin){
  item1.quantity=item1.Quantity;
  item1.MeasureUnit=item1.um;
    var usrid = null;
    if (Common.getWithExpiry("UserType") == '3' && this.IsMuscle) {
      usrid = Common.getWithExpiry("UserID") + Common.getWithExpiry("CustID");
    }
    else {
      usrid = Common.getWithExpiry("CustID");
    }
    var getitem12 = {
      items: item1.itemname,
      warehouse: Common.getWithExpiry("warehouse"),
      company_sy: Common.getWithExpiry("company_sy")
    }
    // Use the existing cart price as fallback — avoids inserting with wrong price if BulkPrice API returns empty
    item1.list_price = (item1.parsedPrice != null && item1.parsedPrice != undefined && item1.parsedPrice > 0) ? item1.parsedPrice : 1;
    // this.dataService.getProductavailibity(getitem12).subscribe((res: any) => {
    //   var availdata = res;
      var bulkPrice = [];

      bulkPrice.push({
        "customer": Common.getWithExpiry("CustID"),
        "item": item1.itemname,
        "quantity": item1.quantity,
        "warehouse": Common.getWithExpiry("warehouse"),
        "rounding": this.PriceRound,
        "qty_unit": item1.MeasureUnit,
        "company_sy": Common.getWithExpiry("company_sy")
      })
      this.cartService.getBulkPrice(bulkPrice).subscribe((res: any) => {
        var pricedata = res;

        if (pricedata != undefined && pricedata.length > 0) {
          item1.list_price = parseFloat(pricedata[0].extension) / parseFloat(pricedata[0].quantity);
          
      
        }

        //item1.totqty = parseFloat(item1.Quantity) * parseFloat(item1.um_displayQty.toString());
        //item1.TotQty = item1.TotQty + parseFloat(item1.Quantity) * parseFloat(item1.um_displayQty.toString());
      
        
        this.cartService.addProductToCart( item1, item1.MeasureUnit).subscribe((res: any) => {
        if(indexs==(lastin-1)){
          this.getCartItems();
        }
          //this.cartService.cartBroadCaster(res);
        })
      })
    //});
    
 }
 ClearCart() {
  
  for (let prs of this.products) {
    this.cartService.deleteCartItemForSession(prs.itemnumber, prs.MeasureUnit).subscribe((res: any) => {
  //    this.getCartItems();
    //  this.cartService.cartBroadCaster(res);
    });
  }
} 

  // @HostListener('document:click', ['$event']) onDocumentClick(event) {
  //   this.showAutoComplete = false;
  // }
}
